import styled from "styled-components/macro";

import PaymentTypeHandler from "Giving/ManageMyGivingPage/PaymentTypeHandler";
import { motion } from "framer-motion";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";

import { getSafeFundColor } from "Utilities/getSafeFundColor";

import { useRecurringGifts } from "../../../RecurringGiftsContext";

export default function ApplyToPledgeCheckbox() {
  const { state, dispatch } = useRecurringGifts();

  const { title, pledge } = state.editModal.giftDetails.campaignData || {};
  const { hasExistingPledge } = state.editModal.giftDetails.userData;
  const { fundColor } = state.editModal.giftDetails.fund;
  const fundColorSafe = fundColor ? getSafeFundColor(fundColor) : null;

  const { applyToExistingPledge } = state.editModal.giftWithEdits;
  const { paymentType } = state.editModal.currentGift;
  const paymentTypeHandler = new PaymentTypeHandler(paymentType);

  const toggle = () => {
    dispatch({
      type: "setApplyToExistingPledge",
      payload: !applyToExistingPledge,
    });
  };

  if (!pledge || !hasExistingPledge) return null;

  return (
    <Wrapper>
      <IconWrapper>
        <Icon className="fa-hand-holding-usd fad" />
      </IconWrapper>
      <Content>
        <FnrCheckbox
          on={applyToExistingPledge}
          toggleOn={toggle}
          color="#278DC1"
        >
          Apply these {paymentTypeHandler.plural()} to {title}
        </FnrCheckbox>
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  width: 60px;
  min-width: 60px;
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  background: transparent;
`;
